import http from "../axios";

const allActiveSchApi = {
    // 获取日常数据
    getSchoolList(data){
        return http({
            url:'/DailyData/SchoolList',
            method:'POST',
            data:data
        })
    },
    // 获取学校下当前的年级和学科
    getGradeSubject(data){
        return http({
            url:"/DailyData/GradeOrSubjectDetails",
            method:'POST',
            data:data
        })
    },
    // 日常数据—学校教师明细-一级分类
    getTeaDetailsFirst(data){
        return http({
            url:"/DailyData/TeaDetailsFirst",
            method:'POST',
            data:data
        })
    },
    // 日常数据—学校教师明细-二级分类
    getTeaDetailsSecond(data){
        return http({
            url:"/DailyData/TeaDetailsSecond",
            method:'POST',
            data:data
        })
    },
    // 日常数据-年级活跃
    getGradeAct(data){
        return http({
            url:"/DailyData/Grade",
            method:'POST',
            data:data
        })
    },
    // 日常数据-学科活跃
    getSubjectAct(data){
        return http({
            url:"/DailyData/Subject",
            method:'POST',
            data:data
        })
    },
    // 日常数据—学科年级教师明细-一级分类
    getSubjectTeaDetailsFirst(data){
        return http({
            url:"/DailyData/SubjectTeaDetailsFirst",
            method:'POST',
            data:data
        })
    },
    // 日常数据—学科年级教师明细-二级分类
    getSubjectTeaDetailsSecond(data){
        return http({
            url:"/DailyData/SubjectTeaDetailsSecond",
            method:'POST',
            data:data
        })
    },
}
export default allActiveSchApi